import { register } from '../../../Javascript/Utils'

const component = el => {
  console.log('el', el)

  el.addEventListener('change', (event) => {
    console.log('event', event)
    console.log('el value', el.value)

    const uri = el.value

    console.log('uri', uri)

    window.location.replace(uri)
  })
}

document.addEventListener('DOMContentLoaded', function () {
  const selectElemente = document.querySelectorAll('.select-wrapper select')

  selectElemente.forEach(selectElement => {
    // Initialer Check und Setup für jede select-Änderung
    aktualisiereSelectWrapperKlasseBasierendAufAttribut(selectElement)
    selectElement.addEventListener('change', function () {
      aktualisiereSelectWrapperKlasseBasierendAufAttribut(this)
    })
  })
})

function aktualisiereSelectWrapperKlasseBasierendAufAttribut (selectElement) {
  const divElement = selectElement.closest('.select-wrapper')
  // Überprüfe, ob irgendeine Option das Attribut 'selected' hat
  const optionMitSelectedAttribut = selectElement.querySelector('option[selected]')
  if (optionMitSelectedAttribut) {
    divElement.classList.add('selected')
  } else {
    divElement.classList.remove('selected')
  }
}

register('StudyOverviewNewsPluginFilter', component)
